import { isIranMarket } from '@parsina/framework/ui/lib/brand';
import { SECTIONS, isValidSection } from '@parsina/framework/clinical/src/screens/Settings/Settings.shared';

// ─────────────────────────────────────────────────────────────────────────────
// The settings sections this deployment offers. The registry is the kit's
// (Settings.shared.js SECTIONS); which of them a market has is the panel's call.
//
// «نسخه» is Iranian through and through — what a visit bills as is the RVU3 visit
// code, read against the doctor's degree in the Iranian medical council's
// register — so outside the Iranian market (`market: 'intl'`,
// docs/rebranding/CONTRACT.md) the tab is not offered, and an address naming it
// lands on the default section like any unknown one. In the Iranian market, and
// with no brand at all, this is SECTIONS itself.
// ─────────────────────────────────────────────────────────────────────────────

const IRAN_ONLY_SECTIONS = ['prescription'];

export function visibleSections() {
  return isIranMarket() ? SECTIONS : SECTIONS.filter((s) => !IRAN_ONLY_SECTIONS.includes(s.id));
}

export const isVisibleSection = (id) => isValidSection(id) && visibleSections().some((s) => s.id === id);
